<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.1525 3C11.1314 7.49309 7.49309 11.1314 3 11.1525C3.40131 6.83669 6.83669 3.40131 11.1525 3Z" fill="black" />
    <path d="M11.1525 3C11.1314 7.49309 7.49309 11.1314 3 11.1525C3.40131 6.83669 6.83669 3.40131 11.1525 3Z" :fill="`url(#${componentId}_paint0_linear_4224_1714)`" />
    <path
      d="M12.8473 3C17.1632 3.40124 20.5988 6.83674 21 11.1526C15.5708 11.1737 11.1737 15.5708 11.1527 21C6.83673 20.5988 3.40124 17.1633 3 12.8473C8.42914 12.8263 12.8263 8.42914 12.8473 3Z"
      fill="black"
    />
    <path
      d="M12.8473 3C17.1632 3.40124 20.5988 6.83674 21 11.1526C15.5708 11.1737 11.1737 15.5708 11.1527 21C6.83673 20.5988 3.40124 17.1633 3 12.8473C8.42914 12.8263 12.8263 8.42914 12.8473 3Z"
      :fill="`url(#${componentId}_paint1_linear_4224_1714)`"
    />
    <path d="M21.0001 12.8474C20.5988 17.1632 17.1635 20.5985 12.8477 20.9999C12.8687 16.5068 16.507 12.8685 21.0001 12.8474Z" fill="black" />
    <path
      d="M21.0001 12.8474C20.5988 17.1632 17.1635 20.5985 12.8477 20.9999C12.8687 16.5068 16.507 12.8685 21.0001 12.8474Z"
      :fill="`url(#${componentId}_paint2_linear_4224_1714)`"
    />
    <foreignObject
      x="0.5"
      y="11.5"
      width="12"
      height="12"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(0.25px); clip-path: url(#${componentId}_bgblur_0_4224_1714_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <g :filter="`url(#${componentId}_filter0_i_4224_1714)`" data-figma-bg-blur-radius="0.5">
      <circle cx="6.5" cy="17.5" r="5.5" fill="#77FFDB" fill-opacity="0.5" />
      <circle cx="6.5" cy="17.5" r="5.5" fill="#77F19E" fill-opacity="0.3" />
      <circle cx="6.5" cy="17.5" r="5.375" :stroke="`url(#${componentId}_paint3_linear_4224_1714)`" stroke-width="0.25" />
    </g>
    <defs>
      <filter
        :id="`${componentId}_filter0_i_4224_1714`"
        x="0.5"
        y="11.5"
        width="12"
        height="12"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="0.0418636" dy="0.0209318" />
        <feGaussianBlur stdDeviation="0.104659" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4224_1714" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_0_4224_1714_clip_path`" transform="translate(-0.5 -11.5)"><circle cx="6.5" cy="17.5" r="5.5" /></clipPath>
      <linearGradient
        :id="`${componentId}_paint0_linear_4224_1714`"
        x1="3"
        y1="7.07623"
        x2="11.1525"
        y2="7.07623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#57EBDE" />
        <stop offset="1" stop-color="#AEFB2A" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_4224_1714`"
        x1="3"
        y1="12"
        x2="21"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#57EBDE" />
        <stop offset="1" stop-color="#AEFB2A" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint2_linear_4224_1714`"
        x1="12.8477"
        y1="16.9236"
        x2="21.0001"
        y2="16.9236"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#57EBDE" />
        <stop offset="1" stop-color="#AEFB2A" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint3_linear_4224_1714`"
        x1="2.75102"
        y1="13.2815"
        x2="9.76785"
        y2="21.972"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
